module.exports = __webpack_public_path__ + "static/media/bacarat-removebg-preview.e5af7f3d.png";